import { render } from "./BalanceSheetSalesman.vue?vue&type=template&id=48fed460"
import script from "./BalanceSheetSalesman.vue?vue&type=script&lang=js"
export * from "./BalanceSheetSalesman.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__